import Papa from 'papaparse'

const locationJsonCsvToCsv = async (locationsCsvJson: any[]): Promise<File> => {
  const csvContent = Papa.unparse(locationsCsvJson)

  return new File([csvContent], 'test.csv', { type: 'text/csv' })
}

export default locationJsonCsvToCsv
